import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id ABC572E9-CE00-450F-A1E0-E59BCF0C3DC3
 * name gamepad-round-down
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-round-down.svg
 * tags
 * - Gaming / RPG 
 */
export const GamepadRoundDownIcon = createSvgIcon(<><path d="M4,8H8V4A2,2 0 0,1 10,2H14A2,2 0 0,1 16,4V8H20A2,2 0 0,1 22,10V14A2,2 0 0,1 20,16H16V20A2,2 0 0,1 14,22H10A2,2 0 0,1 8,20V16H4A2,2 0 0,1 2,14V10A2,2 0 0,1 4,8M10,16V20H14V16H10Z" /></>, 'GamepadRoundDownIcon');
export default GamepadRoundDownIcon